import React, { useLayoutEffect, useRef } from 'react';

let timer;
const Component = ({
  height, filterable, legendLayout, active, setActive, getShortenedName, checkedData, scrollPosition, setScrollPosition,
}) => {
  const legendContainerRef = useRef(null);

  useLayoutEffect(() => {
    if (scrollPosition && legendContainerRef) {
      legendContainerRef.current.scrollTop = scrollPosition;
    }
  }, [scrollPosition, active]);

  const onScrollLegendContainer = (e) => {
    if (timer) {
      clearTimeout(timer);
    }
    const { scrollTop } = e.target;
    if (scrollTop !== scrollPosition) {
      timer = setTimeout(() => {
        setScrollPosition(e.target.scrollTop);
      }, 50);
    }
  };

  const onClickLegendItem = (o) => {
    const { dataKey } = o;
    setActive({
      ...active,
      [dataKey]: !active[dataKey],
    });
  };

  const shortenedHeight = height - (filterable ? 90 : 30);
  return (
    <div
      ref={legendContainerRef}
      className={`legendContainer ${legendLayout} ${filterable ? 'filterable' : 'static'}`}
      style={{ height: shortenedHeight >= 30 ? shortenedHeight : height }}
      onScroll={onScrollLegendContainer}
    >
      {
        checkedData.map((entry, index) => (
          <div key={`item-${index}`} className="legendItem" onClick={() => onClickLegendItem(entry)}>
            <div className="legendSquare" style={{ backgroundColor: entry.color }} />
            <span>{getShortenedName(entry.value, entry)}</span>
          </div>
        ))
      }
    </div>
  );
};

const inputsAreEqual = (prev, next) => (
  JSON.stringify(prev.scrollPosition) === JSON.stringify(next.scrollPosition)
    && JSON.stringify(prev.active) === JSON.stringify(next.active)
    && JSON.stringify(prev.checkedData) === JSON.stringify(next.checkedData)
);

export const FilterLegend = React.memo(Component, inputsAreEqual);
